<h1 style="background-color: #5091cd; color: White;
  font-family: 'Helvetica Neue, Helvetica, Arial, sans-serif'; padding: 8px">
  Scan ID: {{ scanId }}
</h1>
<img [src]="signedUrl$ | async" />